<template>
  <span :class="rankCssClass">{{ rank }}</span>
</template>

<script>
export default {
  name: 'RankComponent',
  props: ['rank'],
  computed: {
    rankCssClass() {
      let cls = '';

      switch (this.rank) {
      case 1:
        cls = 'first';
        break;
      case 2:
        cls = 'second';
        break;
      case 3:
        cls = 'third';
        break;
      default:
        cls = '';
      }

      return cls;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/common.scss' as *;

.first, .second, .third {
  font-weight: bold;
  display: block;
  margin: 0 auto;
  border: 2px solid transparent;
  background-color: white;
  border-radius: 50%;
  width: 1.2em;
  line-height: 1.3em;
}
.first {
  border-color: gold;
}
.second {
  border-color: silver;
}
.third {
  border-color: #cd7f32;
}
</style>
